import { color } from "../../../constant/color";
import Button from "../../Button";
import CloseIcon from "../../CloseIcon";
import React, { useEffect, useState } from "react";
import "./style.css";
import toast from "react-hot-toast";
import axios from "../../../utils/axios";
import { companyController } from "../../../Controller/CompanyController";
import { Input, Select } from "antd";
import { meterController } from "../../../Controller/meterController";
import { flattenArr } from "../../../HelperFunctions";
import Submeter from "../../../screens/Submeter";
import SubmeterTable from "../Table/SubmeterResponse";

const AddMultiple = ({ closeBtn, refreshBtn }) => {
  const { Option } = Select;
  const [serialid, setSerialid] = useState("");
  const [meterid, setMeterid] = useState("");
  const [metermodel, setMeterModel] = useState([]);
  const [selectedmodel, setselectedmodel] = useState("");
  const [loading, setLoading] = useState(false);
  const [prefix, setPrefix] = useState("");
  const [numberofsubmeters, setnumberofsubmeters] = useState(0);
  const [submeters, setsubmeters] = useState([]);
  const [response, setresponse] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [error, seterror] = useState("");

  useEffect(() => {
    (async () => {
      try {
        let res = await axios.post(
          `/devicemanagement/submeter/getallmetermodels`,
          {}
        );

        let result = meterController(res);
        if (result.message !== "success") {
          toast.error(result.message);
        }

        setMeterModel(result.data.body.map((i) => i.devicemodel));
      } catch (err) {
        toast.error(err.message);
      }
    })();
  }, []);

  const handleSubmeter = async () => {
    try {
      if (!/^[1-9]/.test(prefix.toString())) {
        seterror("Prefix must start with a numbers between 1 and 9 (not 0)");
        setTimeout(() => {
          seterror(null);
        }, 10000);
        return;
      }

      if (!prefix || !numberofsubmeters || !selectedmodel)
        return toast.error("All values are required");

      setLoading((prev) => true);
      let res = await axios.post(
        "/devicemanagement/submeter/createsubmetermultiple",
        {
          prefix,
          numberofsubmeters,
          metermodel: selectedmodel,
        }
      );
      let result = companyController(res);

      if (result.type !== "success") {
        toast[result.type](result.message);
        setLoading((prev) => false);
        return;
      }

      // console.log(result, "result");

      if (!Object.keys(result.message?.body[0]).length) {
        toast.error("Failed to create submeter");
        setLoading((prev) => false);
        return;
      }

      toast.success("Submeter created successfully");

      setLoading((prev) => false);
      refreshBtn((prev) => !prev);
      closeBtn(false);
    } catch (err) {
      toast.error(err.message);
      setLoading((prev) => false);
    }
  };
  return (
    <div className="backdrop">
      {showTable && <SubmeterTable data={response} closeModal={closeBtn} />}
      <div
        className="submeter-add_modal animate__animated animate__fadeInUp bg-white rounded-3"
        style={{
          display: showTable ? "none" : "block",
        }}
      >
        <div className="container-fluid">
          <div className="d-flex align-items-center justify-content-between">
            <div className="pt-4 modal-title pb-2">
              Fill the input fields to a create a multiple submeter
            </div>
            <div>
              <div className="" onClick={() => closeBtn(false)}>
                <CloseIcon />
              </div>
            </div>
          </div>

          {error && (
            <p
              className="text-danger"
              style={{
                fontSize: 13,
              }}
            >
              {error}{" "}
            </p>
          )}

          <div className="row">
            <div className="col-12">
              <div class="mb-3 company-entry">
                <label for="exampleInputEmail1" class="form-label">
                  Number of submeter
                </label>
                <Input
                  size="large"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  placeholder="number of submeter.."
                  value={numberofsubmeters}
                  onChange={(e) => setnumberofsubmeters(e.target.value)}
                />
              </div>
              <div class="mb-3 company-entry">
                <label for="exampleInputEmail1" class="form-label">
                  Prefix
                </label>
                <Input
                  size="large"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  placeholder="prefix (must be 3 digits)"
                  onInput={(e) => {
                    if (e.target.value.length > e.target.maxLength) {
                      e.target.value = e.target.value.slice(
                        0,
                        e.target.maxLength
                      );
                    }
                  }}
                  maxLength="3"
                  type={"text"}
                  value={prefix}
                  onChange={(e) => setPrefix(e.target.value)}
                />
              </div>

              <div class="mb-3 company-entry">
                <label for="exampleInputEmail1" class="form-label">
                  Select a meter model
                </label>

                <div className="w-100">
                  <Select
                    className="form-input w-100"
                    placeholder={"select a meter model"}
                    onChange={(e) => setselectedmodel(e)}
                    size="large"
                  >
                    {metermodel.map((i) => (
                      <Option key={i} value={i}>
                        {i}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>
              <div className="my-4" onClick={() => handleSubmeter()}>
                <Button
                  text={"Create"}
                  color={color.white}
                  bgColor={color.primary}
                  fontSize={"15px"}
                  height={"45px"}
                  status={loading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMultiple;
